import React, { Component } from 'react'
import ContactInfoFormWrap from '../share/ContactInfoFormForWelcomecomeWarp';
import trim from 'lodash/trim';
import isEmpty from 'lodash/isEmpty';

import cs from 'classnames';
import {connect} from 'react-redux';
import {regEmail, regZip, regZipCanada, regPhone, regDot, regMc, regPassWord} from '~/misc/reg';
import {errorInfoConfig} from '~/misc/error-info';
import {formatPhone, formatNumberOnly, formatCanadaZip} from '~/misc/formatPhone';
import {getFetchedJSON} from '~/misc/fetch';

import Button from '~/components/common/Button';

import {signUpInWelcome} from '~/modules/user/actions';
import {getUserVerifyData, getUserW9form, uploadW9form, uploadInfoFromEmail} from '~/modules/user/actions';
import mapDispatch from '~/misc/mapDispatch';

import css from './WelcomeProcess.css'
import VerifyAccount from '../share/VerifyAccount';
import Upload from '../BidVerfiy/component/upload';
import {push as changeURL} from 'react-router-redux';
class WelcomeProcess extends Component {
  constructor(props) {
    super(props);
    this.state = {
      contactInfo: {
        email:'',
        basicFirstName:'',
        basicLastName: '',
        basicPhone: '',
        basicCompany :'',
        basicDot: '',
        basicMc: '',
        new_password:'',
        confirm_password: ''
      },
      formControl: {},
      processNumber: 1
    };
  }
  componentDidMount() {
    const params = new URLSearchParams(window.location.search);
    const email = params.get('email');
    return this.setState({
      contactInfo: {
        ...this.state.contactInfo,
        email,
      },
    });
  }
  handleChangeContactInput = (e) => {
    return this.setState({
      contactInfo: {
        ...this.state.contactInfo,
        [e.target.name]: e.target.value,
      },
    });
  }
  handleContactInputBlur = (e) => {
    this.handleBlur('contactInfo', e);
  }
  handleContactDotMcBlur = (e) => {
    this.blurDotMc('contactInfo', e);
  }
  handleBlur = (stateType, e) => {
    const name = e.target.name;
    const type = e.target.getAttribute('data-inputType');
    const inputVal = trim(e.target.value);

    switch (type) {
      case 'password': {
        return this.regData(
          stateType,
          inputVal,
          errorInfoConfig.password.empty,
          errorInfoConfig.password.wrong,
          regPassWord,
          name
        );
      }
      case 'text': {
        return this.regData(
          stateType,
          inputVal,
          errorInfoConfig.text.empty,
          errorInfoConfig.text.wrong,
          false,
          name
        );
      }
      case 'zip': {
        // 美国的zip格式
        if (
          (name.includes('company')
            && this.state[stateType].companyCountry
            && this.state[stateType].companyCountry === 'United States')
          || (name.includes('bill')
            && this.state[stateType].billCountry
            && this.state[stateType].billCountry === 'United States')
        ) {
          return this.regData(
            stateType,
            formatNumberOnly(inputVal, 5),
            errorInfoConfig.zip.empty,
            errorInfoConfig.zip.wrong,
            regZip,
            name
          );
        }

        // 加拿大的zip格式
        return this.regData(
          stateType,
          formatCanadaZip(inputVal),
          errorInfoConfig.zip.empty,
          errorInfoConfig.zip.wrong,
          regZipCanada,
          name
        );
      }
      case 'email': {
        return this.regData(
          stateType,
          inputVal,
          errorInfoConfig.email.empty,
          errorInfoConfig.email.wrong,
          regEmail,
          name
        );
      }
      case 'phone': {
        return this.regData(
          stateType,
          formatPhone(inputVal),
          errorInfoConfig.phone.empty,
          errorInfoConfig.phone.wrong,
          regPhone,
          name
        );
      }
      case 'notNeed': {
        return this.regData(
          stateType,
          inputVal,
          '',
          '',
          false,
          name
        );
      }
      case 'dot': {
        return this.regData(
          stateType,
          formatNumberOnly(inputVal, 7),
          '',
          errorInfoConfig.dot.wrong,
          regDot,
          name);
      }
      case 'mc': {
        return this.regData(
          stateType,
          formatNumberOnly(inputVal, 6),
          '',
          errorInfoConfig.mc.wrong,
          regMc,
          name);
      }
    }
    return null;
  }
  blurDotMc = (stateType, e) => {
    const name = e.target.name;
    const type = e.target.getAttribute('data-inputType');
    const inputVal = trim(e.target.value);

    switch (type) {
      case 'dot': {
        if (!regDot.test(inputVal)) {
          return this.regData(
            stateType,
            formatNumberOnly(inputVal, 7),
            '',
            errorInfoConfig.dot.wrong,
            regDot,
            name);
        }

        return window.fetch(`https://api.truckerpath.com/services/saferwatch/dot/${inputVal}`, {
          method: 'GET',
        })
          .then(getFetchedJSON)
          .then(res => {
            const data = {
              companyDot: inputVal,
              companyMc: res['CarrierService.CarrierLookup'].CarrierDetails.docketNumber
                ? res['CarrierService.CarrierLookup'].CarrierDetails.docketNumber.slice(2)
                : '',
              companyName: res.identity.legalName,
            };
            this.regData(
              stateType,
              data.companyDot,
              '',
              '',
              false,
              'basicDot'
            );
            this.regData(
              stateType,
              data.companyName,
              errorInfoConfig.text.empty,
              errorInfoConfig.text.wrong,
              false,
              'basicCompany'
            );
            this.regData(
              stateType,
              data.companyMc,
              '',
              '',
              false,
              'basicMc'
            );
          })
          .catch(() => {
            this.processDataAndSetState(stateType, name, errorInfoConfig.dot.wrong, inputVal, true);
          });
      }
      case 'mc': {
        if (!regMc.test(inputVal)) {
          return this.regData(
            stateType,
            formatNumberOnly(inputVal, 6),
            '',
            errorInfoConfig.mc.wrong,
            regMc,
            'basicMc');
        }

        return window.fetch(`https://api.truckerpath.com/services/saferwatch/mc/${inputVal}`, {
          method: 'GET',
        })
          .then(getFetchedJSON)
          .then(res => {
            const data = {
              companyDot: res['CarrierService.CarrierLookup'].CarrierDetails.dotNumber['#text'],
              companyMc: inputVal,
              companyName: res.identity.legalName,
            };
            this.regData(
              stateType,
              data.companyDot,
              '',
              '',
              false,
              'basicDot'
            );
            this.regData(
              stateType,
              data.companyName,
              errorInfoConfig.text.empty,
              errorInfoConfig.text.wrong,
              false,
              'basicCompany'
            );
            this.regData(
              stateType,
              data.companyMc,
              '',
              '',
              false,
              'basicMc'
            );
          })
          .catch(() => {
            this.processDataAndSetState(stateType, name, errorInfoConfig.mc.wrong, inputVal, true);
          });
      }
    }
    return null;
  }
  regData = (stateType, inputVal, emptyErrorTips, wrongErrorTips, regMethodType, typeName) => {
    if (!inputVal) {
      return this.processDataAndSetState(stateType, typeName, emptyErrorTips, inputVal, false);
    }
    if (regMethodType && !regMethodType.test(inputVal)) {
      return this.processDataAndSetState(stateType, typeName, wrongErrorTips, inputVal, false);
    }
    return this.processDataAndSetState(stateType, typeName, '', inputVal, true);
  }
  processDataAndSetState = (stateType, typeName, errorTips, inputVal, clickType) => {
    return this.setState({
      [stateType]: {
        ...this.state[stateType],
        [typeName]: inputVal,
      },
      formControl: {
        ...this.state.formControl,
        [typeName]: {
          error: errorTips,
          onClick: clickType,
        },
      },
    });
  }
  submitAccountInfo = () => {

    let data = this.state.contactInfo

    const connectFormValue = data;

    let emptyValue = {};

    // dot 和 mc  有一项存在即可

    Object.keys(connectFormValue).forEach((key) => {
      if (!connectFormValue[key] && key !== 'basicMc' && key !== 'basicExt') { // judge empty value except MC
        if (key === 'email') {
          emptyValue[key] = {
            error: errorInfoConfig.email.empty,
            onClick: false,
          };
        }
        if (key === 'basicDot') {
          emptyValue[key] = {
            error: errorInfoConfig.dot.empty,
            onClick: false,
          };
        }
        if (key === 'basicPhone') {
          emptyValue[key] = {
            error: errorInfoConfig.phone.empty,
            onClick: false,
          };
        }
        emptyValue[key] = {
          error: errorInfoConfig.text.empty,
          onClick: false,
        };
      } else if (this.state.formControl[key] && this.state.formControl[key].error) {
        emptyValue[key] = this.state.formControl[key];
      } else {
        if(key==='confirm_password' && connectFormValue['confirm_password'] !== connectFormValue['new_password']) {
          emptyValue[key] = {
            error: "pass unlike",
            onClick: false,
          };
        }
      }
    });
    
    if (isEmpty(emptyValue)) {
      if (data.basicPhone) {data.basicPhone = formatNumberOnly(data.basicPhone);}
      console.log(data, emptyValue);
      return this.props.signUp({
        email: data.email,
        firstName: data.basicFirstName,
        lastName: data.basicLastName,
        phone: data.basicPhone,
        dot: data.basicDot,
        mc: data.basicMc,
        companyName: data.basicCompany,
        password: data.new_password,
      }).then(()=>{
        this.showPhoneCheck();
        this.updateUserInfo();
      })
    }

    const controlData = Object.assign(this.state.formControl, emptyValue);
    return this.setState({
      formControl: controlData,
    });
  }
  showPhoneCheck = () => {
    this.setState({
      processNumber: 2
    })
  }
  uploadImg = (file) => {
    const { id, token } = this.state;
    const { uploadImg } = this.props;
    return uploadImg({
      id,
      token,
      file,
    })
  }
  uploadInfo = (pics) => {
    const { id, token } = this.state;
    const { uploadInfo } = this.props;
    const { companyName, legalName, phone, mc, dot, authority } = this.props.user
    const files = {
      info: {
        companyName, legalName, phone, mc, dot, authority 
      },
      pics
    }
    return uploadInfo({
      id,
      token,
      files,
    }).then(this.props.goToFrontPage)
  } 
  updateUserInfo = () => {
    this.props.updateUser().then(()=>{
      const { path, status } = this.props.user.w9form;
      const queryString = path.replace(/^.+?\?/, '');
      const query = new URLSearchParams(queryString);
      const id = query.get('id');
      const token = query.get('token');
      const queryStatus = query.get('status');
      if(status) {
        this.setState({
          page: "Success"
        })
      }else if(queryStatus === "NoDotMc") {
        this.setState({
          page: "NotVerified"
        })
      }else if (queryStatus === "pending") {
        this.setState({
          page: "Pending"
        })
      }else {
        this.setState({
          id,
          token
        })
        this.props.getW9Info({
          id,
          token
        })
      }
    })
  }
  render() {
    const { processNumber } = this.state; 
    return (
      <div className={css.warp}>
        <div className={css.title}>
          Carrier Network Verification
        </div>
        <div className={css.desc}>
          <div className={css.secordTitle}>Account Information</div>
          <div className={css.descContent}>
            Please complete and verify your account information. Please verify your phone number and your DOT in order for you to move on to the next step.
          </div>
        </div>
        <div className={css.form}>
          <ContactInfoFormWrap
            contactInfo={this.state.contactInfo}
            errorControl={this.state.formControl}
            handleChange={this.handleChangeContactInput}
            handleBlur={this.handleContactInputBlur}
            handleDotMcBlur={this.handleContactDotMcBlur}
          />
        </div>
        <div className={css.buttoWarp}>
          <Button
            onClick={this.submitAccountInfo}
            className={cs(css.floatRight, css.button)}
            mods={['large', 'action']}
          >Next</Button>
        </div>
        
        {
          processNumber > 1 &&
          <div className={css.verify}>
            <VerifyAccount
              from='email'
            />
          </div>
        }
        {
          this.props.user.emailVerified && this.props.user.verified_phone &&
          <div className={css.upload}>
            <div className={css.uploaderHr}></div>
            <div className={css.secordTitle}>Upload Documents</div>
            <div className={css.descContent}>
              To join our carrier network, please upload the following documents below. By providing these documents, it will allow us to help you onboard with our partnered brokers/shippers whenever is needed.
            </div>
            <Upload
              uploadImg = {this.uploadImg}
              uploadInfo = {this.uploadInfo}
            ></Upload>
          </div>
        }
      </div>
      
    )
  }
}

export default connect(
  ({user, dots}) => ({user, dots}
), mapDispatch({
  signUp: (props, { email,
    firstName,
    lastName,
    phone,
    dot,
    mc,
    companyName,
    password,}) => signUpInWelcome({
      email,
      firstName,
      lastName,
      phone,
      dot,
      mc,
      companyName,
      password,
    }),
    updateUser: ()=> getUserVerifyData(),
    getW9Info: (props ,{id, token})=>  getUserW9form(id, token),
    uploadImg: (props, {id, token, file}) => uploadW9form(id, token, file),
    uploadInfo: (props, {id, token, files}) => uploadInfoFromEmail (id, token, files),
    goToFrontPage: () => changeURL('/'),
}))(WelcomeProcess);


// WEBPACK FOOTER //
// ./src/components/pages/MyAccount/WelcomeProcess/index.js